import { useGetQuery, useLazyGetQuery, usePostMutation } from "slices/api";
import { BILLING_CYCLE } from "tagTypes";

export const useGetBillingCyclesQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/billing-cycle",
    query,
    tags: [BILLING_CYCLE],
  });

export const useGetBillingCycleByIdQuery = (billingCycleId) =>
  useGetQuery({
    endpoint: `/billing-cycle/${billingCycleId}`,
    tags: [BILLING_CYCLE],
  });

export const useGetAllSourceOfPowerQuery = (billingCycleId) =>
  useGetQuery({
    endpoint: "/source-of-power",
    tags: [BILLING_CYCLE],
  });

  export const useLazyGetAllSourceOfPowerQuery = () => {
  const [getAllSourceOfPower, data] = useLazyGetQuery();
  const getAllSourceOfPowerData = async () =>
    await getAllSourceOfPower(
      {
        endpoint: "/source-of-power",
        tags: [BILLING_CYCLE],
      },
      true
    ).unwrap();
  return [getAllSourceOfPowerData, data];
};

export const useGetBillingCycleOptionsQuery = () =>
  useGetQuery({
    endpoint: "/billing-cycle/billing-options",
    tags: [BILLING_CYCLE],
  });

export const useLazyGetBillingCycleOptionsQuery = () => {
  const [getBillingOptions, data] = useLazyGetQuery();
  const fetchBillingOptions = async () =>
    await getBillingOptions(
      {
        endpoint: "/billing-cycle/billing-options",
        tags: [BILLING_CYCLE],
      },
      true
    ).unwrap();
  return [fetchBillingOptions, data];
};

export const useLazyGetBillingCycleByIdQuery = () => {
  const [getBillingCycleData, data] = useLazyGetQuery();
  const getBillingCycles = async (billingCycleId, query = {}) =>
    await getBillingCycleData(
      {
        endpoint: `/billing-cycle/${billingCycleId}`,
        query,
        tags: [BILLING_CYCLE],
      },
      true
    ).unwrap();
  return [getBillingCycles, data];
};

export const usePostBillingCycleMutation = () => {
  const [setBillingCycle, data] = usePostMutation();
  const addBillingCycle = async (payload, query = {}) =>
    await setBillingCycle({
      endpoint: "/billing-cycle",
      query,
      payload: payload || {},
      toastMessage: "Billing cycle added successfully",
      tags: [BILLING_CYCLE],
    }).unwrap();
  return [addBillingCycle, data];
};
